import React from 'react';
import { withRouter } from 'react-router-dom';
import LimitSettings from 'components/assessments_pages/asessment_settings_components/LimitSettings';
import DeadlineSettings from 'components/assessments_pages/asessment_settings_components/DeadlineSettings';
import AutoExtendSettings from 'components/assessments_pages/asessment_settings_components/AutoExtendSettings';
import TimeExtensionRequest from 'components/assessments_pages/asessment_settings_components/TimeExtensionRequest';
import TimeframeSettings from 'components/assessments_pages/asessment_settings_components/TimeframeSettings';


const DeadlinePage = ({ ...other }) => (
    <div>
        <LimitSettings {...other} />
        <DeadlineSettings {...other} />
        <TimeExtensionRequest {...other} />
        <AutoExtendSettings {...other} />
        <TimeframeSettings {...other} />
    </div>
);

export default withRouter(DeadlinePage);
